import React from "react";

function SortTask({ onSort, colourBlindMode }) {
    const getBackgroundColor = (colourBlindMode) => {
        switch (colourBlindMode) {
            case true:
                return "bg-[#FFF5EB]"
            default:
                return "bg-[#fff6e0]";
        }
      };
    return (
        <div className="dropdown-center">
            <button
                className={`${getBackgroundColor(colourBlindMode)} btn btn-secondary sort-filter-btn`}
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
            >
                Sort <i className="fa-solid fa-arrow-down-short-wide"></i>
            </button>
            <ul className="dropdown-menu">
                <li>
                    <button
                        className={`${getBackgroundColor(colourBlindMode)} dropdown-item sort-filter-dropdown-item`}
                        onClick={() => {
                            onSort("lowToUrgent");
                        }}
                    >
                        Low to Urgent
                    </button>
                </li>
                <li>
                    <button
                        className={`${getBackgroundColor(colourBlindMode)} dropdown-item sort-filter-dropdown-item`}
                        onClick={() => onSort("urgentToLow")}
                    >
                        Urgent to Low
                    </button>
                </li>
                <li>
                    <button
                        className={`${getBackgroundColor(colourBlindMode)} dropdown-item sort-filter-dropdown-item`}
                        onClick={() => onSort("recentToOldest")}
                    >
                        Recent to Oldest
                    </button>
                </li>
                <li>
                    <button
                        className={`${getBackgroundColor(colourBlindMode)} dropdown-item sort-filter-dropdown-item`}
                        onClick={() => onSort("oldestToRecent")}
                    >
                        Oldest to Recent
                    </button>
                </li>
                <li>
                    <button
                        className={`${getBackgroundColor(colourBlindMode)} dropdown-item sort-filter-dropdown-item`}
                        onClick={() => onSort("none")}
                    >
                        Default
                    </button>
                </li>
            </ul>
        </div>
    );
}

export default SortTask;
